import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "app"
};
import { detectDeviceType } from '@/utils';
export default {
  __name: 'App',
  setup(__props) {
    const deviceKey = ref(detectDeviceType());
    document.title = "上海亦芯文化传媒有限公司 - 全链路整合营销服务商";

    // 监听窗口大小变化
    // const handleResize = () => {
    //   const newDeviceType = detectDeviceType()
    //   // 只有设备类型改变时才更新
    //   if (newDeviceType !== deviceKey.value) {
    //     deviceKey.value = newDeviceType
    //   }
    // }
    //
    // watch(deviceKey, () => {
    //   location.reload()
    // })
    // // 组件挂载时添加监听器
    // onMounted(() => {
    //   window.addEventListener('resize', handleResize)
    // })
    //
    // // 组件卸载时移除监听器
    // onUnmounted(() => {
    //   window.removeEventListener('resize', handleResize)
    // })

    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view)]);
    };
  }
};